// @flow
import React from 'react';

import { INLINE_1, INLINE_2 } from 'Components/frameworks/card/Card.constants';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

type Props = {
  config: CMSContent,
  countryInfos: {
    texts?: Array<{
      description?: string,
      media: { mediaUrl: string, mediaAlt: string },
      title?: string,
    }>,
  },
  cta?: Array<{ label: string, link: string }>,
  id?: string,
};

export function CountryInfosLine({
  config: {
    common: { close },
  },
  countryInfos: { texts = [] },
  cta = [],
  id,
}: Props) {
  const cards = texts.map(
    ({ description = '', media: { mediaAlt = '', mediaUrl = '' } = {}, title = '' }, index) => {
      return {
        closeLabel: close,
        ctaLabel: cta[index] && cta[index].label,
        heading: {
          title,
          hLevel: 3,
        },
        link: { url: cta[index] && cta[index].link },
        media: {
          url: mediaUrl,
          alt: mediaAlt,
        },
        text: {
          text: description,
        },
        theme: 'landing',
      };
    },
  );

  if (!cards.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      {cards.map((card, index) => {
        const cardLayout = index % 2 === 0 ? INLINE_1 : INLINE_2;
        return (
          <Card
            {...card}
            key={card.heading.title}
            className={index ? 'mt-5' : ''}
            layout={cardLayout}
          />
        );
      })}
    </SiteContainer>
  );
}
